import React from 'react';
import logo from '../footerwhite.svg'; // Adjust the path as necessary
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebookF, faTwitter, faInstagram, faLinkedinIn } from '@fortawesome/free-brands-svg-icons';
import {
  faPhone,
  faEnvelope,
  faLocationDot,
} from '@fortawesome/free-solid-svg-icons';
function Footer() {
  return (
    <div class="footer-8-area-bg bg_image pt--65">
      <div class="container pb--65">
        <div class="row">
          <div class="col-lg-3">    
            <div class="footer-logo-area-left-8">
              <a href="#" class="logo">
                <img src={logo} alt="finbiz-logo" className="logo-width" />
              </a>
          
              <ul class="social-area-wrapper-two">
                <li>
                  <a href="#">
          <FontAwesomeIcon icon={faFacebookF} size="lg" style={{ color: 'white' }} />
              
                  </a>
                </li>
                <li>
                  <a href="#">
    <FontAwesomeIcon icon={faTwitter} size="lg" style={{ color: 'white' }}/>
                  </a>
                </li>
                <li>
                  <a href="#">
    <FontAwesomeIcon icon={faLinkedinIn} size="lg" style={{ color: 'white' }}/>
                  </a>
                </li>
                <li>
                  <a href="#">
      <FontAwesomeIcon icon={faInstagram} size="lg" style={{ color: 'white' }}/>
                  </a>
                </li>
              
              </ul>
            </div>
          </div>
       
          <div class="col-lg-9">
            <div class="footer-one-single-wized">
              <div class="wized-title">
                <h5 class="title">Contact Us</h5>
               
              </div>
              <div class="quick-link-inner">
                <div class="signle-footer-contact-8">
                  <div class="icon">
       <FontAwesomeIcon icon={faPhone}  style={{ color: 'white' }}/>
                  </div>
                  <div class="inner-content">
                    <h5 class="title">Call Us 24/7</h5>
                    <a href="tel:+91-9865250178">9865250178</a>
                  </div>
                </div>
                <div class="signle-footer-contact-8">
                  <div class="icon">
               <FontAwesomeIcon icon={faEnvelope}  style={{ color: 'white' }}/>
                  </div>
                  <div class="inner-content">
                    <h5 class="title">Work with us</h5>
                    <a href="mailto:qualityfirst@conquestasia.com">qualityfirst@conquestasia.com</a>
                  </div>
                </div>
                <div class="signle-footer-contact-8">
                  <div class="icon">
          <FontAwesomeIcon icon={faLocationDot}  style={{ color: 'white' }}/>
                  </div>
                  <div class="inner-content">
                    <h5 class="title">Our Location</h5>
                    <a href="#">
                  Conquest Quality Systems Services Pvt. Ltd.<br/>
SF No. 183/1A, Kaniyampoondi, Vanjipalayam, Tirupur- 641 663 INDIA.
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="copyright-area-main-wrapper">
        <div class="container">
          <div class="row">
            <div class="col-lg-12">
              <div class="copyright-8-wrapper">
                <p>
                  Conquestasia - Copyright
                  <script>document.write( new Date().getFullYear() )</script>
                  2025. All rights reserved.
                </p>
                <ul>
                  <li>
                    <a href="/">Home</a>
                  </li>
                  <li>
                    <a href="/about">About Us</a>
                  </li>
                   <li>
                    <a href="/ourCoreInspectionService">Services</a>
                  </li>
                    <li>
                    <a href="/contact">Contact Us</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Footer;
